<template>
  <div class="local-home">
    <h1>{{ msg }}</h1>

    <p>
    空間知能化のお勉強をしましょう。
    </p>

<h2>
firebaseの概要：工事中
</h2>

<h4>
もくじ
</h4>

<div class="talka">
<ol>
<li>
<a href="#1">Firebaseの概要</a>
</li>
<li>
<a href="#2">Firebase SDK</a>
</li>
</ol>

</div>


<h3 id="1">
1.Firebaseの概要
</h3>

<p>
「<a href="https://www.topgate.co.jp/firebase01-what-is-firebase">【第1回】 Google の mBaaS 「 Firebase 」とは？【はじめてみよう Firebase】</a>」を引用しました。
</p>

<div class="talka">

<h4>
Firebase とは
</h4>

<ul>
<li>
Firebase は Google が提供しているモバイルおよび Web アプリケーションのバックエンドサービスです。クラウドサービスの形態では BaaS に位置付けされます。
</li>
<li>
 Firebase を使うことで、開発者はアプリケーションの開発に専念でき、バックエンドで動くサービスを作成する必要も管理する必要もありません。
</li>
<li>
サービスの早期リリースという要件が求められたときに、サーバレスアーキテクチャが注目され、 BaaS というクラウドサービスの形態が登場しました。
</li>
<li>
サーバサイドの開発費を抑え、かつ工数もかからない。サービスの利用者が増えてもサーバの増築を意識しなくて良いなどの利点から、 Web サービスほどサーバを必要としないモバイル向けのサービスの BaaS に注目され、様々な BaaS が登場しました。
Firebase もその中の一つです。 
</li>
<li>
Firebase はもともとは Google とは独立したサービスでしたが、2014年に Google に買収され、 GCP の仲間入りをしました。
</li>
<li>
現在は GCP の様々なサービスと連携して使うことができるようになっています。
</li>
</ul>


<h4>
Firebaseの機能
</h4>

<ul>
<li>
BaaS には、独自のビジネスロジックを組み込むことはできません。
</li>
<li>
そのため、多くの BaaS には、データベース機能以外にも、 SNS 連携や Android 、 iOS の SDK などが提供されています。
</li>
<li>
煩わしい認証は SDK が BaaS と連携してくれて、クライアントは数行のコードを書くだけで実現することができます。
</li>
<li>
もちろん Firebase にもこういった機能がサポートされており、 Firebase では以下のような機能が提供されています。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/firebase-01_mbaas.png" width="100%">
<figcaption align="center">図1: Firebaseの概要</figcaption>
</figure>


<h4>
Realtime Database
</h4>

<ul>
<li>
Firebase に元から含まれているオブジェクト型のデータベースです。
</li>
<li>
リアルタイムでクライアント全体の状態を同期させることができ、オフラインで動作するときはデータをキャッシュしてオンラインになった時に自動的にデータを同期します。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/firebase-01_FirebaseRealtimeDatabase.png" width="100%">
<figcaption align="center">図2: Realtime Database</figcaption>
</figure>


<h4>
Cloud Firestore
</h4>

<ul>
<li>
Realtime Database の性能をさらに向上させた、新しい主力のデータベースです。
</li>
<li>
Realtime Database より高速でスケールアウトにも対応しています。こちらもオブジェクト型のデータベースとなっています。
</li>
<li>
現在ベータ版となっていますが、 Google は Realtime Database より Cloud Firestore を推奨しているため、今後は Realtime Database に取って代わるデータベースになるように思われます。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/firebase-01_CloudFirestore.png" width="100%">
<figcaption align="center">図3: Cloud Firestore</figcaption>
</figure>

<h4>
Cloud Storage for Firebase
</h4>

<ul>
<li>
写真や動画などバイナリーデータを保存します。保存先は Cloud Storage となっており、 Firebase と Google Cloud の両方からアクセスできます。
</li>
<li>
また、スケールアウト機能も兼ね備えており、急激なアプリケーションの拡大にも対応しています。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/firebase-01_CloudStorageforFirebase.png" width="100%">
<figcaption align="center">図4: Cloud Storage for Firebase</figcaption>
</figure>

<h4>
Firebase Authentication
</h4>

<ul>
<li>
Firebase Authentication は、Google のフェデレーション認証で、Google 以外にも Facebook 、GitHub 、Twitter などのサードパーティの認証情報を使用して、クライアントアプリケーションのログインを行うことができます。
</li>
<li>
また、フェデレーション ID 以外にもパスワード認証や電話番号認証にも対応しています。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/firebase-01_FirebaseAuthentication.png" width="100%">
<figcaption align="center">図5: Firebase Authenticatione</figcaption>
</figure>

<h4>
Firebase Cloud Messaging（FCM）
</h4>

<ul>
<li>
Firebase Cloud Messaging を使うことで、様々なプラットホームで動いているアプリケーションに対してメッセージを送ることができます。
</li>
<li>
今までは Google Cloud Message を使ってサーバからのプッシュ通知を行っていましたが、これからは、Firebase Cloud Messaging を使うことが推奨されています。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/firebase-01_FirebaseCloudMessaging.png" width="100%">
<figcaption align="center">図6: Firebase Cloud Messaging（FCM）</figcaption>
</figure>

<h4>
Google Cloud Functions for Firebase
</h4>

<ul>
<li>
Cloud Functions for Firebase を使うことで、イベントドリブンなアプリケーションを作成することができます。 
</li>
<li>
SMS メッセージの送信などの処理のような外部サービス連携などを行うことが可能になります。
</li>
<li>
また、クライアントアプリケーションに実装させるには重たすぎるような処理を Cloud Functions for Firebase に委ねることができます。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/firebase-01_CloudFunctionsforFirebase.png" width="100%">
<figcaption align="center">図7: Google Cloud Functions for Firebase</figcaption>
</figure>

<h4>
Firebase Hosting
</h4>

<ul>
<li>
Firebase Hosting はスタティックな Web ページを公開することができます。
</li>
<li>
近年では HTML 、 CSS 、 Javascript を組み合わせてアプリケーションのような Web ページを実現することができるようになりました。
</li>
<li>
こういった Web ページも Firebase Hosting を使って公開することもできます。
</li>
<li>
また、 Web ページでは、エッジキャッシュの機能を利用することができので、世界各地に分散している Google のエッジ接続拠点を使って高速にユーザに配信することができます。
</li>
</ul>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/firebase-01_FirebaseHosting.png" width="100%">
<figcaption align="center">図8: Firebase Hosting</figcaption>
</figure>


<h4>
その他
</h4>

<ul>
<li>
その他に、<a href="https://firebase.google.com/?hl=ja">Test Lab for Android や Performance Monitoring</a> などの機能があります。
</li>
</ul>


</div>

<h3 id="2">
2.Firebase SDK
</h3>


<div class="talka">

<h4>
Firebase とは
</h4>

<ul>
<li>
</li>
</ul>


</div>


  </div> <!-- end of local-home -->

</template>

<script>
import Vue from 'vue'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)

export default {
  name: 'DanceWorld',
  props: {
    msg: String
  },
  data() {
    return {
      //album_index: 0,
      //album_title : 'ワルツ',
      //video_index: 0,
      //video_title : '01 いきいきストレッチング',

      //video_index_1: 0,
      //video_id: '5IlfzLYadNk',

      //albums: [],
    }
  },
  created () {
    //this.albums = [this.album_1, this.album_2, this.album_3, this.album_4, this.album_5, this.album_6, this.album_7]
    //this.firstVideo()
  },
  methods: {
    /*
    selectAlbum(index) {
      window.console.log("selectAlbum() 1.index: " + index);
      this.album_index = index;
      this.firstVideo()
    },
    */
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smart-display {
  //margin-left: 20px;
}

.talka {
  margin-left: 10px;
}

pre {
background-color: #ffffaa;
}

h3 {
  margin: 40px 0 0;
}
ol {
  //list-style-type: none;
  padding: 0;
}
ul {
  //list-style-type: none;
  margin-left: 20px;
  padding: 0;
}
li {
  //display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
